export default __webpack_public_path__ + "static/media/magGlass.52291ac8.png";